import { Checkbox } from "../Checkbox/Checkbox";
import "./link.css";

export const Link = ({ type = '', href = '/#', children }) => {
    const handleClick = e => {
        e.preventDefault();
        if (href) {
            window.location.href = href;
        }
    };

    return (
        <span className="link-wrapper">
            <a href={href || '/#'} className={type} onClick={handleClick}>
                {type === 'checkbox-link' && <Checkbox />}
                {children}
            </a>
        </span>
    );
};
